const  homePage = {
  bankcomm: '/home/bankcomm'
}

export default  homePage